// Generated by scripts/build-ui-icons.mjs.
import { createAppIcon } from "./base";
import { CookingPotIcon as CookingPotGlyph } from "@phosphor-icons/react/dist/ssr/CookingPot";
import { CopyIcon as CopyGlyph } from "@phosphor-icons/react/dist/ssr/Copy";
import { CopySimpleIcon as CopySimpleGlyph } from "@phosphor-icons/react/dist/ssr/CopySimple";
import { CornersOutIcon as CornersOutGlyph } from "@phosphor-icons/react/dist/ssr/CornersOut";
import { CrosshairIcon as CrosshairGlyph } from "@phosphor-icons/react/dist/ssr/Crosshair";
import { CurrencyCircleDollarIcon as CurrencyCircleDollarGlyph } from "@phosphor-icons/react/dist/ssr/CurrencyCircleDollar";
import { CurrencyDollarIcon as CurrencyDollarGlyph } from "@phosphor-icons/react/dist/ssr/CurrencyDollar";
import { CursorIcon as CursorGlyph } from "@phosphor-icons/react/dist/ssr/Cursor";
import { CursorClickIcon as CursorClickGlyph } from "@phosphor-icons/react/dist/ssr/CursorClick";
import { DatabaseIcon as DatabaseGlyph } from "@phosphor-icons/react/dist/ssr/Database";
import { DetectiveIcon as DetectiveGlyph } from "@phosphor-icons/react/dist/ssr/Detective";
import { DeviceMobileIcon as DeviceMobileGlyph } from "@phosphor-icons/react/dist/ssr/DeviceMobile";
import { DoorIcon as DoorGlyph } from "@phosphor-icons/react/dist/ssr/Door";
import { DotOutlineIcon as DotOutlineGlyph } from "@phosphor-icons/react/dist/ssr/DotOutline";
import { DotsSixVerticalIcon as DotsSixVerticalGlyph } from "@phosphor-icons/react/dist/ssr/DotsSixVertical";
import { DotsThreeIcon as DotsThreeGlyph } from "@phosphor-icons/react/dist/ssr/DotsThree";
import { DotsThreeVerticalIcon as DotsThreeVerticalGlyph } from "@phosphor-icons/react/dist/ssr/DotsThreeVertical";
import { DownloadSimpleIcon as DownloadSimpleGlyph } from "@phosphor-icons/react/dist/ssr/DownloadSimple";
import { DropIcon as DropGlyph } from "@phosphor-icons/react/dist/ssr/Drop";
import { EnvelopeSimpleIcon as EnvelopeSimpleGlyph } from "@phosphor-icons/react/dist/ssr/EnvelopeSimple";
import { EnvelopeSimpleOpenIcon as EnvelopeSimpleOpenGlyph } from "@phosphor-icons/react/dist/ssr/EnvelopeSimpleOpen";
import { EyeIcon as EyeGlyph } from "@phosphor-icons/react/dist/ssr/Eye";
import { EyeSlashIcon as EyeSlashGlyph } from "@phosphor-icons/react/dist/ssr/EyeSlash";
import { FacebookLogoIcon as FacebookLogoGlyph } from "@phosphor-icons/react/dist/ssr/FacebookLogo";
import { FactoryIcon as FactoryGlyph } from "@phosphor-icons/react/dist/ssr/Factory";
import { FileArrowUpIcon as FileArrowUpGlyph } from "@phosphor-icons/react/dist/ssr/FileArrowUp";
import { FileCodeIcon as FileCodeGlyph } from "@phosphor-icons/react/dist/ssr/FileCode";
import { FileCsvIcon as FileCsvGlyph } from "@phosphor-icons/react/dist/ssr/FileCsv";
import { FileDocIcon as FileDocGlyph } from "@phosphor-icons/react/dist/ssr/FileDoc";
import { FileImageIcon as FileImageGlyph } from "@phosphor-icons/react/dist/ssr/FileImage";
import { FileLockIcon as FileLockGlyph } from "@phosphor-icons/react/dist/ssr/FileLock";
import { FileMagnifyingGlassIcon as FileMagnifyingGlassGlyph } from "@phosphor-icons/react/dist/ssr/FileMagnifyingGlass";
import { FilePdfIcon as FilePdfGlyph } from "@phosphor-icons/react/dist/ssr/FilePdf";
import { FilePptIcon as FilePptGlyph } from "@phosphor-icons/react/dist/ssr/FilePpt";
import { FileTextIcon as FileTextGlyph } from "@phosphor-icons/react/dist/ssr/FileText";

export const CookingPot = /* @__PURE__ */ createAppIcon(
  CookingPotGlyph,
  "CookingPot",
);
export const Copy = /* @__PURE__ */ createAppIcon(CopyGlyph, "Copy");
export const CopySimple = /* @__PURE__ */ createAppIcon(
  CopySimpleGlyph,
  "CopySimple",
);
export const CornersOut = /* @__PURE__ */ createAppIcon(
  CornersOutGlyph,
  "CornersOut",
);
export const Crosshair = /* @__PURE__ */ createAppIcon(
  CrosshairGlyph,
  "Crosshair",
);
export const CurrencyCircleDollar = /* @__PURE__ */ createAppIcon(
  CurrencyCircleDollarGlyph,
  "CurrencyCircleDollar",
);
export const CurrencyDollar = /* @__PURE__ */ createAppIcon(
  CurrencyDollarGlyph,
  "CurrencyDollar",
);
export const Cursor = /* @__PURE__ */ createAppIcon(CursorGlyph, "Cursor");
export const CursorClick = /* @__PURE__ */ createAppIcon(
  CursorClickGlyph,
  "CursorClick",
);
export const Database = /* @__PURE__ */ createAppIcon(
  DatabaseGlyph,
  "Database",
);
export const Detective = /* @__PURE__ */ createAppIcon(
  DetectiveGlyph,
  "Detective",
);
export const DeviceMobile = /* @__PURE__ */ createAppIcon(
  DeviceMobileGlyph,
  "DeviceMobile",
);
export const Door = /* @__PURE__ */ createAppIcon(DoorGlyph, "Door");
export const DotOutline = /* @__PURE__ */ createAppIcon(
  DotOutlineGlyph,
  "DotOutline",
);
export const DotsSixVertical = /* @__PURE__ */ createAppIcon(
  DotsSixVerticalGlyph,
  "DotsSixVertical",
);
export const DotsThree = /* @__PURE__ */ createAppIcon(
  DotsThreeGlyph,
  "DotsThree",
);
export const DotsThreeVertical = /* @__PURE__ */ createAppIcon(
  DotsThreeVerticalGlyph,
  "DotsThreeVertical",
);
export const DownloadSimple = /* @__PURE__ */ createAppIcon(
  DownloadSimpleGlyph,
  "DownloadSimple",
);
export const Drop = /* @__PURE__ */ createAppIcon(DropGlyph, "Drop");
export const EnvelopeSimple = /* @__PURE__ */ createAppIcon(
  EnvelopeSimpleGlyph,
  "EnvelopeSimple",
);
export const EnvelopeSimpleOpen = /* @__PURE__ */ createAppIcon(
  EnvelopeSimpleOpenGlyph,
  "EnvelopeSimpleOpen",
);
export const Eye = /* @__PURE__ */ createAppIcon(EyeGlyph, "Eye");
export const EyeSlash = /* @__PURE__ */ createAppIcon(
  EyeSlashGlyph,
  "EyeSlash",
);
export const FacebookLogo = /* @__PURE__ */ createAppIcon(
  FacebookLogoGlyph,
  "FacebookLogo",
);
export const Factory = /* @__PURE__ */ createAppIcon(FactoryGlyph, "Factory");
export const FileArrowUp = /* @__PURE__ */ createAppIcon(
  FileArrowUpGlyph,
  "FileArrowUp",
);
export const FileCode = /* @__PURE__ */ createAppIcon(
  FileCodeGlyph,
  "FileCode",
);
export const FileCsv = /* @__PURE__ */ createAppIcon(FileCsvGlyph, "FileCsv");
export const FileDoc = /* @__PURE__ */ createAppIcon(FileDocGlyph, "FileDoc");
export const FileImage = /* @__PURE__ */ createAppIcon(
  FileImageGlyph,
  "FileImage",
);
export const FileLock = /* @__PURE__ */ createAppIcon(
  FileLockGlyph,
  "FileLock",
);
export const FileMagnifyingGlass = /* @__PURE__ */ createAppIcon(
  FileMagnifyingGlassGlyph,
  "FileMagnifyingGlass",
);
export const FilePdf = /* @__PURE__ */ createAppIcon(FilePdfGlyph, "FilePdf");
export const FilePpt = /* @__PURE__ */ createAppIcon(FilePptGlyph, "FilePpt");
export const FileText = /* @__PURE__ */ createAppIcon(
  FileTextGlyph,
  "FileText",
);
